export default {
    user(state) {
        return state.user
    },
    vueauth_token(state) {
        return state.vueauth_token
    },
    vueauth_token_expiry(state) {
        return state.vueauth_token_expiry
    },
    userId(state) {
        return state.userId
    },
    scopes(state) {
        return state.scopes
    },
    hasScopes(state) {
        return (...scopes) => {
            return _.intersection(scopes, state.scopes).length
        }
    },
}
